import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ArticleGenerationRow } from '../../types/articleGeneration';
import MaterialIcon from '../shared/MaterialIcon';

interface Props {
  run: ArticleGenerationRow;
  /** History opens should reveal the inputs immediately; the fresh flow keeps them tucked away. */
  defaultOpen?: boolean;
}

const ArticleInputs: React.FC<Props> = ({ run, defaultOpen = false }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(defaultOpen);
  const i = run.inputs;

  const rows: [string, string][] = [
    [t('article.mode_label'), t(`article.mode_${run.mode}`, run.mode)],
    [t('article.primary_keyword'), i.primaryKeyword || '–'],
    [t('article.secondary_keywords'), i.secondaryKeywords.join(', ') || '–'],
    [t('article.heading_count'), String(i.headingCount)],
    [t('article.section_length'), i.sectionLength ? t(`article.section_length_${i.sectionLength}`) : '–'],
    [t('article.context_language'), i.language || '–'],
    [t('article.context_tone'), i.toneOfVoice || '–'],
    [t('article.context_target_group'), i.customerGroupDescription || '–'],
    [t('article.source_notes'), i.sourceNotes || '–'],
    [t('article.quotes'), i.quotes || '–'],
    [t('article.source_data'), i.sourceData || '–'],
    [t('common.custom_prompt'), i.customPrompt || '–'],
  ];

  return (
    <section className="border rounded-lg">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center gap-1 px-4 py-2 text-left font-semibold text-sm"
      >
        <MaterialIcon name={open ? 'expand_more' : 'chevron_right'} className="text-base" />
        {t('article.inputs_title')}
      </button>
      {open && (
        <dl className="px-4 pb-4 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-3 text-sm">
          {rows.map(([label, value]) => (
            <div key={label}>
              <dt className="text-gray-500">{label}</dt>
              <dd className="whitespace-pre-wrap break-words">{value}</dd>
            </div>
          ))}
        </dl>
      )}
    </section>
  );
};

export default ArticleInputs;
